import type * as Types from '../../../__generated__/bffGlobalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CreateOrUpdateWebhookUrlVariables = Types.Exact<{
  webhookUrl: Types.Scalars['String']['input'];
}>;


export type CreateOrUpdateWebhookUrl = {
  createOrUpdateWebhookUrl: {
    __typename?: 'CreateOrUpdateWebhookUrlResponse',
    success: boolean,
    webhookUrl: string | null
  }
};


export const CreateOrUpdateWebhookUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrUpdateWebhookUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"webhookUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrUpdateWebhookUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"webhookUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"webhookUrl"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"webhookUrl"}}]}}]}}]} as unknown as DocumentNode<CreateOrUpdateWebhookUrl, CreateOrUpdateWebhookUrlVariables>;